import React from "react";
import Pagination from "../components/Pagination/Pagination";
import SelectInput from "../components/UI/Inputs/SelectInput";


interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  paginationLinks: any[];
  itemsPerPage: number;
  itemsPerPageOptions: number[];
  onPageChange: (url: string | null) => void;
  onItemsPerPageChange: (value: number) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  paginationLinks,
  itemsPerPage,
  itemsPerPageOptions,
  onPageChange,
  onItemsPerPageChange,
}) => {
  return (
    <div className="d-flex gap-5 align-items-center justify-content-end flex-wrap">
      <div className="d-flex gap-3 align-items-center">
        <div className="fs-13 text-black text-nowrap">Items per page</div>
        <div className="form-group">
          <SelectInput
            options={itemsPerPageOptions.map((item) => ({
              value: item,
              label: item.toString(),
            }))}
            onChange={(value) => onItemsPerPageChange(Number(value))}
            className="form-select text-only"
            value={itemsPerPage}
          />
        </div>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        paginationLinks={paginationLinks}
        maxVisiblePages={5} // You can make this configurable if needed
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default PaginationControls;